module.exports = __webpack_public_path__ + "141d4a85/img/upload-icon.9179ae4e.svg";